// FAQSection.jsx - FAQ section with expandable answers
import React, { useState } from 'react';
import { ChevronDown, HelpCircle } from 'lucide-react';

export default function FAQSection({ faqs = [], title = "Frequently Asked Questions" }) {
  const [openIndex, setOpenIndex] = useState(0);

  if (faqs.length === 0) return null;

  return (
    <section className="mt-14 pt-10 border-t border-gray-100">
      <div className="flex items-center gap-3 mb-8">
        <div className="w-10 h-10 rounded-xl bg-[#FFB800] flex items-center justify-center shadow-sm">
          <HelpCircle size={18} className="text-[#172A3A]" />
        </div>
        <h2 className="text-2xl font-bold text-[#172A3A]">{title}</h2>
      </div>
      <div className="space-y-3">
        {faqs.map((faq, idx) => {
          const isOpen = openIndex === idx;
          return (
            <div
              key={idx}
              className={`rounded-xl border transition-all duration-200 ${
                isOpen
                  ? 'border-[#FFB800]/40 bg-gradient-to-br from-amber-50/50 to-white shadow-sm'
                  : 'border-gray-200 bg-white hover:border-gray-300'
              }`}
            >
              <button
                onClick={() => setOpenIndex(isOpen ? -1 : idx)}
                className="w-full flex items-center justify-between p-5 text-left transition-colors"
              >
                <span className={`font-semibold pr-4 leading-snug ${
                  isOpen ? 'text-[#172A3A]' : 'text-gray-700'
                }`}>
                  {faq.question}
                </span>
                <div className={`w-7 h-7 rounded-lg flex items-center justify-center flex-shrink-0 transition-all ${
                  isOpen ? 'bg-[#FFB800]/20 rotate-180' : 'bg-gray-100'
                }`}>
                  <ChevronDown
                    size={16}
                    className={isOpen ? 'text-[#FFB800]' : 'text-gray-400'}
                  />
                </div>
              </button>
              <div className={`overflow-hidden transition-all duration-200 ${
                isOpen ? 'max-h-96 opacity-100' : 'max-h-0 opacity-0'
              }`}>
                <div className="px-5 pb-5 text-gray-600 leading-relaxed text-[0.95rem]">
                  {faq.answer}
                </div>
              </div>
            </div>
          );
        })}
      </div>
    </section>
  );
}
